<template>
  <div class="educationIndex">
    <h2 class="sr-only">愛樹教育</h2>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "EducationIndex"
};
</script>
<style lang="scss" scoped>
.caseIndex {
  height: 100%;
}
</style>
